import { zSchema } from "@zeal/common";

const rotationPeriodDaysSchema = zSchema.union([
  zSchema.literal(60),
  zSchema.literal(90),
  zSchema.literal(180),
]);

const sshKeySingleResultSchema = zSchema.object({
  id: zSchema.string(),
  state_code: zSchema.string(),
  key_version: zSchema.number(),
  public_key: zSchema.string(),
  secret_manager_arn: zSchema.string(),
  status: zSchema.string(),
  rotation_period_days: zSchema.number(),
  created_at: zSchema.union([zSchema.string(), zSchema.date()]),
});

export const postSshKeyRotationGenerateRequestSchema = zSchema.union([
  zSchema.object({
    state_code: zSchema.string().min(1),
    rotation_period_days: rotationPeriodDaysSchema,
  }),
  zSchema.object({
    kind: zSchema.literal("single"),
    state_code: zSchema.string().min(1),
    rotation_period_days: rotationPeriodDaysSchema,
  }),
  zSchema.object({
    kind: zSchema.literal("group"),
    state_codes: zSchema.array(zSchema.string().min(1)).min(2),
    rotation_period_days: rotationPeriodDaysSchema,
    key_group_id: zSchema.string().optional(),
    key_group_name: zSchema.string().optional(),
  }),
]);

export type TPostSshKeyRotationGenerateRequestSchema = zSchema.infer<
  typeof postSshKeyRotationGenerateRequestSchema
>;

export const postSshKeyRotationGenerateResponseSchema = zSchema.union([
  sshKeySingleResultSchema,
  zSchema.object({
    kind: zSchema.literal("group"),
    key_group_id: zSchema.string(),
    key_group_name: zSchema.string().optional(),
    items: zSchema.array(sshKeySingleResultSchema),
  }),
]);

export type TPostSshKeyRotationGenerateResponseSchema = zSchema.infer<
  typeof postSshKeyRotationGenerateResponseSchema
>;
